// Import models.
import {
	AddressLocationWithAccuracy,
	BuildingLimitsCommercial,
	BuildingRiskDataCommercial,
} from '@app/models/api';

export default class BuildingResponseCommercial {

	public address: AddressLocationWithAccuracy | null = null;
	public buildingData: BuildingRiskDataCommercial | null = null;
	public limits: BuildingLimitsCommercial | null = null;

	public constructor() {

	}
}